import styled from 'styled-components';
import { rgba, timingFunctions } from 'polished';
import { default as ArrowIcon } from 'components/icons/DropdownArrow';
import { white, brandColors, grey200 } from 'styles/colors';
import { fadeIn } from 'styles/animation';
import { pageToolbarHeight, dropdownSideSpacing } from 'styles/spacings';

export const Wrapper = styled.div`
	position: relative;
	margin: 0 -${dropdownSideSpacing};
`;

export const Label = styled.span`
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	${props =>
		props.disabled
			? `color: ${grey200} !important;`
			: props.open
				? `color: ${brandColors.green}`
				: 'inherit'};
	height: ${pageToolbarHeight};
	flex: 0 0 ${pageToolbarHeight};
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-top: 1px solid transparent;
	border-bottom: ${props =>
		`1px solid ${props.open ? rgba('#d1d1d1', 0.5) : 'transparent'}`};
	transition: ${props =>
		`border-bottom-color ${props.open ? '300ms' : '0'} ease-in-out`};
	padding: 0 ${dropdownSideSpacing};
	cursor: pointer;
	white-space: nowrap;
	user-select: none;
`;

export const Arrow = styled(ArrowIcon)`
	flex: 0 0 auto;
	margin-left: 8px;
	width: 11px;
	height: 6px;
	color: ${props => (props.open ? 'inherit' : grey200)};
	transition: 100ms ease-in-out;
	transition-property: transform, color;
	transform: ${props => !props.open && 'rotate(180deg)'};

	${Label}:hover & {
		color: inherit;
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: ${props => props.leftAlign && 0};
	right: ${props => !props.leftAlign && 0};
	background-color: ${white};
	box-shadow: 0 2px 18px ${rgba('#000', 0.09)};
	white-space: nowrap;
	z-index: 1;
	animation: 300ms ${fadeIn} ${timingFunctions('easeOutExpo')};
	transform-origin: top center;
	display: flex;
	flex-direction: column;
	user-select: none;
	/* Fix rendering in some browsers */
	transform: translateZ(0);
`;

export const Content = styled.div`
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	flex: 0 1 auto;
`;
